<div class="booking">

    <div class="index-head" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="index-head">
            <span>Search Property</span>
        </div>

        <button [attr.guide]="'search-builder-btn-1' + '__' + sanitizeUrl(url)" mat-icon-button>
            <mat-icon (click)="close()">
                close
            </mat-icon>
        </button>
    </div>

    <div class="padding-10" *ngIf="!budgetEnabled || !subLocationEnabled">

        <form [formGroup]="firstFormGroup">
            <div *ngIf="!budgetEnabled" class="padding-10" fxLayout="row" fxLayoutAlign="space-between center"
                fxLayoutGap="20px">
                <mat-form-field fxFlex appearance="outline">
                    <mat-label>Budget</mat-label>
                    <input [attr.guide]="'search-builder-inp-budget' + '__' + sanitizeUrl(url)" numbersOnly matInput formControlName="budget"/>
                    <mat-error
                        *ngIf="firstFormGroup.controls['budget'].invalid && firstFormGroup.controls['budget'].touched">
                        Please fill out this field.
                    </mat-error>
                </mat-form-field>
            </div>
            <div *ngIf="!subLocationEnabled" class="padding-10" fxLayout="row" fxLayoutAlign="space-between center"
                fxLayoutGap="20px">
                <mat-form-field fxFlex appearance="outline">
                    <mat-label>SubLocation</mat-label>
                    <input [attr.guide]="'search-builder-inp-sublocation' + '__' + sanitizeUrl(url)" matInput formControlName="subLocation"/>
                    <mat-error
                        *ngIf="firstFormGroup.controls['subLocation'].invalid && firstFormGroup.controls['subLocation'].touched">
                        Please fill out this field.
                    </mat-error>
                </mat-form-field>
            </div>
        </form>

    </div>

    <div class="padding-11" style="overflow-x: auto;">
        <!-- <div class="padding-10" [formGroup]="firstFormGroup">
        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">

            <mat-form-field fxFlex appearance="outline">
                <mat-label>Search Property</mat-label>
                <mat-select formControlName="customField5"
                    [disableOptionCentering]="true" #singleSelect
                    autocomplete="off">
                    <mat-option>
                        <ngx-mat-select-search name="Property Search"
                            ngDefaultControl [formControl]="typeYFilterControl"
                            placeholderLabel="Property Search"
                            [preventHomeEndKeyPropagation]="true"
                            noEntriesFoundLabel="No data found">
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option
                        *ngFor="let opt of filteredBuilderTypeList; let i=index;"
                        [value]="opt.builderId">
                        {{opt.location}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div> -->

        <div class="editSets" fxLayout="column">
            <calsoft-list [progress]="spinner" (filterChangeColumn)="onFilterChangeColumn($event)"
                [filterSelectObj]="filterSelectObj" name="Builder" [columns]="columns"
                (filterChange)="onFilterChange($event)">

                <div id="responsieTable" class="container">
                    <div [ngClass]="builderList?.length>=5?'minimum':'none'">
                        <table class="rwd-table">
                            <tbody>
                                <tr>
                                    <th>LOCATION</th>
                                    <th>BUILDER</th>
                                    <th>BUDGET</th>
                                    <th>PROJECT NAME</th>
                                    <th>ACTION </th>
                                </tr>

                                <tr *ngFor="let builder of builderList;let i=index">

                                    <td data-th="LOCATION">
                                        {{builder.locationMain}}
                                    </td>
                                    <td data-th="BUILDER">
                                        {{builder.builder}}
                                    </td>
                                    <td data-th="BUDGET">
                                        {{builder.priceRange}}
                                    </td>
                                    <td data-th="PROJECT NAME">
                                        {{builder.projectName}}
                                    </td>
                                    <td data-th="Action">

                                        <button [attr.guide]="'search-builder-btn-2' + '__' + sanitizeUrl(url)" *ngIf="builder.registerProcess=='Copy'"
                                            (click)="getAllBuilderById(builder.builderId , 1)" mat-menu-item>
                                            <mat-icon>content_copy</mat-icon>
                                            <span>Copy Link</span>
                                        </button>

                                        <button [attr.guide]="'search-builder-btn-3' + '__' + sanitizeUrl(url)" *ngIf="builder.registerProcess=='Mail'"
                                            (click)="getAllBuilderById(builder.builderId , 2)" mat-menu-item>
                                            <mat-icon>mail</mat-icon>
                                            <span>Mail</span>
                                        </button>

                                        <button [attr.guide]="'search-builder-btn-4' + '__' + sanitizeUrl(url)" *ngIf="builder.registerProcess=='Whatsapp'"
                                            (click)="getAllBuilderById(builder.builderId , 3)" mat-menu-item
                                            style="display: inline-flex; align-items: center;">
                                            <!-- <img style="height: 30px; width: 25px; margin-right: 5px;"
                                                src="assets/icons/whatsapp.svg" alt="whatsapp"> -->
                                            <calsoft-common-images [src]="'assets/icons/whatsapp.svg'" [height]="'30px'"
                                                [width]="'25px'" [alt]="'whatsapp'">

                                            </calsoft-common-images>
                                            <span style="color: black;">Whatsapp</span>
                                        </button>

                                        <button [attr.guide]="'search-builder-btn-5' + '__' + sanitizeUrl(url)" *ngIf="builder.registerProcess=='Crm'"
                                            (click)="getAllBuilderById(builder.builderId , 4)" mat-menu-item>
                                            <mat-icon>near_me</mat-icon>
                                            <span>Navigation Link</span>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div fxLayout="row" *ngIf="builderList?.length==0" fxLayoutAlign="center center">
                            <span>No Records Found</span>
                        </div>
                    </div>
                </div>

                <div fxLayout="row" class="pager" fxLayoutAlign="end center" fxLayoutGap="5px">
                    <mat-spinner [diameter]="20" *ngIf="spinner"></mat-spinner>
                    <mat-paginator class="paginator" (page)="getUpdate($event)" showFirstLastButtons [length]="pageList"
                        [pageIndex]="page" [pageSize]="size" [pageSizeOptions]="pageSizeValue"> </mat-paginator>
                </div>
            </calsoft-list>
        </div>
    </div>

</div>